export enum TipoModaleEnum {
  ANNULLA,
  ELIMINA,
  CUSTOM
}
